import { some } from 'lodash';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { IQohInventoryItemVenue } from '@app/shared/types/entities/transfer/transfer.type';
import { decimalNumber } from '@app/shared/common/decimal-number/decimal-number';
import { I18n } from '@app/i18n/strings-keys';

export const getInventoryItemVenuesRequireValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const items: IQohInventoryItemVenue[] = control.value;

    const hasQuantityItems = some(items, (item) => {
      const initialCount = decimalNumber(item.initial_count);

      return initialCount.gt(0) || initialCount.lt(0);
    });

    return hasQuantityItems
      ? null
      : { error: I18n.ErrorMessages.TransferNoQuantityItemsError };
  };
};
